<section tuiContent class="text-left">
	<div class="max-w-lg">
		<h2 class="text-primary text-xl mb-0.5 font-semibold">
			{{
				'analyses.dialog.create-analysis-errors.missing-or-incorrect-header'
					| transloco
			}}
		</h2>

		<p>
			{{
				'analyses.dialog.create-analysis-errors.missing-or-incorrect-message'
					| transloco
			}}
		</p>
	</div>

	<div
		class="mt-8 overflow-auto border-primary border-2 rounded-lg relative shadow-md"
	>
		<div
			class="z-10 flex justify-end bg-primary-900 sticky top-0 py-2 px-4 border-b-[1px] border-primary-800"
		>
			<p class="text-xs text-primary font-semibold">
				{{
					'analyses.dialog.create-analysis-errors.error-count-#'
						| transloco: { count: context.data.errors.length }
				}}
			</p>
		</div>

		<cdk-virtual-scroll-viewport class="h-80" appendOnly itemSize="60">
			<div
				*cdkVirtualFor="let error of context.data.errors; let i = index"
				class="py-3 px-4 leading-none border-t-[1px] border-primary-900 flex gap-3"
			>
				@if (error | invoiceError; as data) {
					<p class="text-sm text-primary-500">{{ i + 1 }}</p>
					<div>
						<p class="text-sm" [innerHTML]="data.title"></p>
						<small class="text-xs">{{ data.subtitle }}</small>
					</div>
				}
			</div>
		</cdk-virtual-scroll-viewport>
	</div>
</section>

<footer tuiFooter>
	<button
		size="s"
		tuiButton
		appearance="outline"
		(click)="onDownloadErrors()"
	>
		{{
			'analyses.dialog.create-analysis-errors.action.download-errors'
				| transloco
		}}
	</button>
	<button size="s" tuiButton (click)="onDismiss()">
		{{
			context.data.confirmText ||
				'analyses.dialog.create-analysis-errors.action.reupload'
				| transloco
		}}
	</button>
</footer>
